export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-3">
            联络我们
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            联系我们
          </h2>
          <p className="text-foreground-500 text-sm mt-2">欢迎投稿、合作与反馈</p>
        </div>

        <div className="max-w-lg mx-auto bg-background-50 rounded-2xl p-8 border border-background-200/70 text-center">
          <div className="w-16 h-16 mx-auto mb-5 rounded-2xl bg-accent-100 flex items-center justify-center">
            <i className="ri-mail-send-line text-2xl text-accent-600"></i>
          </div>
          <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2">
            投稿与商务合作
          </h3>
          <p className="text-sm text-foreground-500 leading-relaxed mb-6">
            如果你有好的日漫推荐、原创漫评想与大家分享，或者有商务合作意向，
            欢迎发送邮件至以下地址，我们会在 48 小时内回复。
          </p>
          <div className="inline-flex items-center gap-2 px-5 py-3 rounded-xl bg-background-100 border border-background-200/70">
            <i className="ri-mail-line text-foreground-500"></i>
            <span className="text-sm font-medium text-foreground-800">contact@sakura-anime.com</span>
          </div>
        </div>
      </div>
    </section>
  );
}